import { styled } from "@mui/material";

const StyledSmallImage = styled("img")(({ theme }) => ({
  width: "100%",
  height: "100%",
  objectFit: "cover",
}));

export default StyledSmallImage;
